import type { ReactNode } from "react"
import type { Action } from "../hooks/useAction"

export type NoteTone = "error" | "warn" | "ok" | "info" | "hint"

/**
 * Сообщение над содержимым экрана. Пять тонов на всё приложение:
 *
 * - `error` — не получилось;
 * - `warn` — получится, но не так, как человек ожидает (опасная операция);
 * - `ok` — получилось;
 * - `info` — пояснение к тому, что сейчас на экране;
 * - `hint` — «здесь только чтение» и почему.
 *
 * Раньше у каждого экрана были свои классы под то же самое: `.error`,
 * `.pub-warn`, `.pub-ok`, `.dict-notice`, `.readonly-note`.
 */
export function Note({
	tone = "info",
	onDismiss,
	children,
}: {
	tone?: NoteTone
	/** Клик по сообщению его убирает. Для ошибок и отчётов об успехе. */
	onDismiss?: () => void
	children: ReactNode
}) {
	return (
		<div
			className={`note note--${tone}` + (onDismiss ? " note--dismiss" : "")}
			onClick={onDismiss}
			title={onDismiss ? "Клик — скрыть" : undefined}
		>
			{children}
		</div>
	)
}

/** Ошибка и отчёт об успехе одной операции — то, что показывают все панели записи. */
export function ActionNotes({ action }: { action: Action }) {
	return (
		<>
			{action.error && (
				<Note tone="error" onDismiss={() => action.setError(null)}>
					{action.error}
				</Note>
			)}
			{action.notice && (
				<Note tone="ok" onDismiss={() => action.setNotice(null)}>
					{action.notice}
				</Note>
			)}
		</>
	)
}
